import { JSX, Show } from 'solid-js';
import { Dynamic } from 'solid-js/web';
import { TreeNodeDefinition } from './types';

export interface SelectionTreeSlotContentProps<T = unknown> {
  node: TreeNodeDefinition<T>;
  nodes: readonly TreeNodeDefinition<T>[];
  treeSlot?(
    node: TreeNodeDefinition<T>,
    allNodes: readonly TreeNodeDefinition<T>[]
  ): JSX.Element | undefined;
  nodeSlot?(): JSX.Element;
}

/**
 * Renders tree- or node-level row slot content. Invoked as a function from
 * TreeItem so tree-level slots stay reactive.
 */
export function renderSelectionTreeSlotContent<T = unknown>(
  input: SelectionTreeSlotContentProps<T>
): JSX.Element {
  const nodeContent = (
    <Show when={input.nodeSlot} keyed>
      {(content) => <Dynamic component={content} />}
    </Show>
  );

  if (input.treeSlot !== undefined) {
    return input.treeSlot(input.node, input.nodes) ?? nodeContent;
  }

  return nodeContent;
}
